export default __webpack_public_path__ + "static/topBanner_1-5698762274d10ad124f574614e01aa15.png";